<app-toast></app-toast>
<app-payment-dialog [toast]="toast"></app-payment-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.settings' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.company_information' | transloco }}"
                    link="/settings/company"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.my_profile' | transloco }}"
                    link="/settings/profile"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.team' | transloco }}" link="/settings/team"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.billing' | transloco }}"
                    link="/settings/billing"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.plans' | transloco }}" [isActive]="true"
                    link="/settings/plans"></app-tab-button>
            </div>

            <!-- Header -->
            <div class="mt-10 w-full flex-col text-center justify-center items-center">
                <h1 class="text-5xl font-bold text-black mobile:text-3xl">{{ 'settings.choose_plan_title' | transloco }}
                </h1>
                <p class="mt-5 mobile:text-sm">{{ 'settings.choose_plan_subtitle' | transloco }}</p>
                <div class="mt-5 flex flex-wrap gap-5 w-full items-center justify-center">
                    <p class="font-bold" [ngClass]="billedYearly ? 'text-neutral-500' : 'text-black'">{{
                        'settings.billed_monthly' | transloco }}</p>
                    <app-toggle-button [(toggleButton)]="billedYearly"></app-toggle-button>
                    <p class="font-bold" [ngClass]="!billedYearly ? 'text-neutral-500' : 'text-black'">{{
                        'settings.billed_yearly' | transloco }}</p>
                    <div class="px-2 py-1 rounded-[20px] bg-primary">
                        <p class="text-white">
                            {{ 'settings.save_yearly' | transloco: {precentage: 17} }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- List of available plans -->
            <div
                class="desktop:py-[150px] min-h-[80vh] w-full flex gap-4 justify-center overflow-x-auto mobile:justify-start items-center mobile:py-[150px] scrollbar-hide">
                <ng-container *ngFor="let paymentPlan of listOfPaymentPlans; let i = index">
                    <app-payment-plan [planInfo]="paymentPlan" [billedYearly]="billedYearly"
                        (onPlanSelected)="onPlanSelected(paymentPlan)"></app-payment-plan>
                </ng-container>
            </div>

            <!-- Support features -->
            <p class="font-bold mt-10">{{ 'settings.payment_features.compare_by_category' | transloco }}</p>

            <div
                class="overflow-x-auto mt-5 max-w-ultrawide h-full mobile:max-w-screen overflow-y-auto border-[1px] border-border rounded-[16px] block">
                <table class="table w-full border-collapse">
                    <!-- Header -->
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'settings.payment_features.support_features' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'settings.payment_features.start' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'settings.payment_features.smart'
                                |
                                transloco }}</th>
                        </tr>
                    </thead>
                    <!-- Content -->
                    <tbody>

                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.support_dedicated_photovoltaic_services' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.support_dedicated_mobility_services' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.support_dedicated_consulting_services' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.invoice_check' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.access_to_historic_data' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.archive_all_files' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.csv_file_extraction' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.dashboard_access' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.market_benchmarks' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.price_forecasting' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                        <tr class="max-h-[50px]">
                            <td class="border-b border-border px-4 py-4">{{
                                'settings.payment_features.latest_energy_price_news' | transloco }}</td>
                            <td class="border-b border-border px-4 py-4"></td>
                            <td class="border-b border-border px-4 py-4"><app-invoice-status [status]="true"
                                    statusOkColor="#80A7A5"></app-invoice-status></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>